<template lang="pug">
include ImageMessage.pug
</template>

<script>
import get from 'lodash/get';
import { toggleUserScalableMetaTag } from '../../../../lib/meta';

export default {
  props: {
    message: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    inWebchat: Boolean,
    imgAltText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      senderName: get(this.message, 'senderName', ''),
      channel: this.channel,
      channelInfoTitle: get(this.message, 'channelInfo.title', ''),
      senderType: get(this.message, 'sender_info', ''),
      content: get(this.message, 'content', ''),
      assetThumbUrl: get(this.message, 'thumbnail.url', ''),
      assetUrl: this.message.url,
      assetWidth: this.width,
      assetHeight: this.height,
      previewBoxVisible: false,
      acl: get(this.message, 'acl', 'public'),
      bucket: get(this.message, 'bucket', ''),
      src: get(this.message, 'url', ''),
      key: get(this.message, 'key', ''),
      thumbnailKey: get(this.message, 'thumbnail.key', ''),
    };
  },
  watch: {
    previewBoxVisible(previewBoxIsVisible) {
      if (!navigator.userAgent.includes('iPhone')) {
        const metas = [...document.getElementsByTagName('meta')];
        toggleUserScalableMetaTag(previewBoxIsVisible, metas);
      }
    },
  },
  methods: {
    onLoaded() {
      // FIXME: Not sure why this.$emit('loaded') wouldn't work
      //        It seems due to its weird structure and can't
      //        figure out other way
      this.$parent.$parent.$parent.$emit('loaded', this.message);
    },
  },
};
</script>
